export default __webpack_public_path__ + "static/media/global-guinness-logo-harp-colour.db600c71.svg";